// Source: app/scripts/services/entity-log-helpers.js
/* global Auction */
Auction.factory('EntityLogHelpers', ['$filter', '$window', function ($filter, $window) {
  var mfaActions = {
    TOTP: 'auth.mfa_log_method_totp',
    BACKUP_CODE: 'auth.mfa_log_method_backup',
    SUCCESS: 'auth.mfa_log_success',
    FAILED: 'auth.mfa_log_failed',
    INVALID_CODE: 'auth.mfa_log_invalid_code',
    LOCKED: 'auth.mfa_log_locked',
    PENDING: 'auth.mfa_log_pending',
    ENABLED: 'auth.mfa_log_enabled',
    DISABLED: 'auth.mfa_log_disabled',
    USED: 'auth.mfa_log_used',
    LOGIN: 'auth.mfa_log_login'
  };

  return {
    isMfaLogEntry: function (entry) {
      return entry && entry.performedAction && entry.performedAction.indexOf('MFA_') === 0;
    },
    formatMfaLogValue: function (value) {
      if (!value || value === '-') {
        return '-';
      }
      var key = mfaActions[value];
      return key ? $filter('translate')(key) : value;
    },
    attachLogFilters: function (scope) {
      scope.logFilter = scope.logFilter || 'all';
      scope.isMfaLogEntry = this.isMfaLogEntry;
      scope.formatMfaLogValue = this.formatMfaLogValue;
      scope.filteredLog = function () {
        if (!scope.log) {
          return [];
        }
        if (scope.logFilter === 'mfa') {
          return scope.log.filter(function (entry) {
            return entry && entry.performedAction && entry.performedAction.indexOf('MFA_') === 0;
          });
        }
        return scope.log;
      };
    },
    attachMfaAdminReset: function (scope, entity, resetMfaCall, reloadLog, toaster) {
      var self = this;
      scope.resetUserMfa = function () {
        self.resetUserMfaForEntity(entity, resetMfaCall, toaster, reloadLog);
      };
    },
    resetUserMfaForEntity: function (entity, resetMfaCall, toaster, reloadLog) {
      if (!entity || !entity.username) {
        return;
      }
      if (!$window.confirm($filter('translate')('auth.mfa_admin_reset_confirm'))) {
        return;
      }
      resetMfaCall({username: entity.username}, function () {
        entity.twoFactorEnabled = false;
        if (typeof reloadLog === 'function') {
          reloadLog();
        }
        if (toaster) {
          toaster.pop('success', $filter('translate')('success'),
            $filter('translate')('auth.mfa_admin_reset'));
        }
      });
    }
  };
}]);
